export const SERVICE_NAME = 'linkedin';

export const LINKEDIN_API_VERSION = '202608';
export const LINKEDIN_LEGACY_API_VERSION = 'v2';
export const LINKEDIN_MAIN_API_ROOT = 'https://api.linkedin.com/rest';
export const LINKEDIN_AUTH_API_ROOT = `https://www.linkedin.com/oauth/${LINKEDIN_LEGACY_API_VERSION}`;

export const LINKEDIN_PROFILE_ENDPOINT = `${LINKEDIN_MAIN_API_ROOT}/me`;

export const LINKEDIN_ORGANIZATIONAL_ACCESS_CONTROL_INFORMATION_ENDPOINT = `${LINKEDIN_MAIN_API_ROOT}/organizationAcls?q=roleAssignee&role=ADMINISTRATOR&state=APPROVED`;
export const LINKEDIN_INITIALIZE_IMAGE_UPLOAD_ENDPOINT = `${LINKEDIN_MAIN_API_ROOT}/images?action=initializeUpload`;
export const LINKEDIN_POST_USER_GENERATED_CONTENT_ENDPOINT = `${LINKEDIN_MAIN_API_ROOT}/posts`;
export const LINKEDIN_REFRESH_TOKEN_ENDPOINT = `${LINKEDIN_AUTH_API_ROOT}/accessToken`;
export const LINKEDIN_INTROSPECT_TOKEN_ENDPOINT = `${LINKEDIN_AUTH_API_ROOT}/introspectToken`;
export const LINKEDIN_ORGANIZATION_RETRIEVAL_ENDPOINT = `${LINKEDIN_MAIN_API_ROOT}/organizations`;

export const LINKEDIN_PERSON_URN_PREFIX = 'urn:li:person:';
export const LINKEDIN_ORGANIZATION_URN_PREFIX = 'urn:li:organization';
